import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #fffbeb, #fef3c7)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #f59e0b, #d97706)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  content: {
    padding: '16px'
  },
  statsBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    background: 'white',
    borderRadius: '12px',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  emptyState: {
    textAlign: 'center',
    padding: '40px 20px',
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  obsCard: {
    background: 'white',
    borderRadius: '12px',
    marginBottom: '12px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '2px solid #fef3c7'
  },
  obsHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
    borderBottom: '1px solid #fcd34d'
  },
  obsNumber: {
    background: '#f59e0b',
    color: 'white',
    padding: '4px 10px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '700'
  },
  obsPoint: {
    fontSize: '12px',
    color: '#92400e',
    fontWeight: '600'
  },
  obsContent: {
    padding: '12px 16px'
  },
  obsConstat: {
    fontSize: '14px',
    color: '#374151',
    lineHeight: 1.5
  },
  obsRef: {
    fontSize: '11px',
    color: '#6b7280',
    marginTop: '8px',
    fontStyle: 'italic'
  },
  obsPhotos: {
    display: 'flex',
    gap: '8px',
    marginTop: '12px'
  },
  obsPhoto: {
    width: '60px',
    height: '60px',
    borderRadius: '8px',
    objectFit: 'cover',
    border: '2px solid #e5e7eb'
  },
  deleteBtn: {
    background: '#fee2e2',
    color: '#dc2626',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #16a34a, #15803d)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  }
};

function Etape5ObservationsLevageMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({ observations: [], dernier_numero: 0 });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_11_observations');
      if (savedData) {
        setData(savedData);
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteObservation = async (obsNumero) => {
    if (!window.confirm(`Supprimer l'observation N°${obsNumero} ?`)) return;
    
    const updatedObservations = data.observations.filter(o => o.numero !== obsNumero);
    const newData = { ...data, observations: updatedObservations };
    setData(newData);
    await inspectionStorage.saveStep(mission.id, 'etape_11_observations', newData);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_11_observations', data);
      console.log('✅ Observations levage sauvegardées');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#fffbeb' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: '40px', height: '40px', border: '4px solid #e5e7eb', borderTopColor: '#f59e0b', borderRadius: '50%', animation: 'spin 1s linear infinite', margin: '0 auto' }}></div>
          <p style={{ marginTop: '16px', color: '#92400e', fontWeight: '500' }}>Chargement...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      </div>
    );
  }

  const observations = data.observations || [];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Observations ({observations.length})</h1>
        <button style={styles.backBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      <div style={styles.content}>
        {/* Stats */}
        <div style={styles.statsBadge}>
          <span style={{ fontSize: '24px' }}>🔺</span>
          <div>
            <div style={{ fontWeight: '700', color: '#92400e' }}>{observations.length} observation(s)</div>
            <div style={{ fontSize: '12px', color: '#b45309' }}>
              Ajoutées depuis les points de contrôle
            </div>
          </div>
        </div>

        {/* Liste observations */}
        {observations.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>✓</div>
            <p style={{ fontSize: '16px', fontWeight: '600', color: '#16a34a', marginBottom: '8px' }}>
              Aucune observation
            </p>
            <p style={{ fontSize: '13px', color: '#6b7280' }}>
              Les observations sont ajoutées depuis l'étape 4 (Points de contrôle)
            </p>
          </div>
        ) : (
          observations.map((obs) => (
            <div key={obs.numero} style={styles.obsCard}>
              <div style={styles.obsHeader}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={styles.obsNumber}>N°{obs.numero}</span>
                  <span style={styles.obsPoint}>
                    {obs.element_ref?.section_titre ? `${obs.element_ref.section_titre} - ` : ''}
                    Point {obs.element_ref?.point_numero || obs.element?.replace('Point ', '')}
                  </span>
                </div>
                <button 
                  style={styles.deleteBtn}
                  onClick={() => handleDeleteObservation(obs.numero)}
                >
                  🗑️
                </button>
              </div>
              <div style={styles.obsContent}>
                <p style={styles.obsConstat}>{obs.constat}</p>
                {obs.reference_reglementaire && (
                  <p style={styles.obsRef}>📖 {obs.reference_reglementaire}</p>
                )}
                {obs.photos && obs.photos.length > 0 && (
                  <div style={styles.obsPhotos}>
                    {obs.photos.map((photo, idx) => (
                      <img key={idx} src={photo} style={styles.obsPhoto} alt={`Photo ${idx + 1}`} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      <div style={styles.saveSection}>
        <button style={{ ...styles.saveButton, ...(saving ? { opacity: 0.6 } : {}) }} onClick={handleSave} disabled={saving}>
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape5ObservationsLevageMobile;